import React from 'react'
import SuplierDash from '../Integration/SuplierDash'
import DashboardHeader from '../Integration/DashboardHeader'
import FbBusinessProfileUpdate from '../../Middleware/Firebase/FbBusinessProfileUpdate'





function PageSupplierUpdate() {
  return (
    <div>
      <DashboardHeader/>
      <SuplierDash/>
    <FbBusinessProfileUpdate/>

      </div>
  )
}

export default PageSupplierUpdate